
import { useCallback } from 'react';

type ToastFunction = {
  toast: (props: { title: string; description: string; variant?: "default" | "destructive" }) => void;
};

/**
 * Hook to handle reconnection to the admin server
 */
export const useAdminReconnection = (
  checkConnection: () => Promise<boolean>,
  refreshAttendees: () => Promise<any>,
  refreshAdminData: () => Promise<any>,
  toast: ToastFunction['toast']
) => {
  // Retry connection handler
  const handleRetryConnection = useCallback(async () => {
    toast({
      title: "Đang thử kết nối lại",
      description: "Vui lòng đợi trong giây lát..."
    });
    
    const connected = await checkConnection();
    
    if (connected) {
      // Silently refresh data after reconnection without notification
      await Promise.all([
        refreshAttendees(),
        refreshAdminData()
      ]);
    }
    
    return connected; // Make sure we return a boolean value
  }, [toast, checkConnection, refreshAttendees, refreshAdminData]);
  
  return { handleRetryConnection };
};
